import {
  DownloadPurchaseInvoicePdfSuccess,
  StoreSubscriptionsActionType,
} from './../stores/store-subscriptions/+state/store-subscriptions.actions';
import { StoresCatalogActionType } from '../stores/store-catalog/+state/stores-catalog.actions';
import { StoresActionType } from './../stores/+state/stores.actions';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Directive, OnDestroy, OnInit } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';

import * as FileSaver from 'file-saver';
import { StoreLocationActionType } from '../stores/store-location/+state/store-location.actions';
import { StoreOrderActionType } from '../stores/store-order/+state/store-order.actions';
import { UserActionType } from '../user/+state/user.actions';
import { PlatformActionType } from '../store-platform/+state/platform.actions';
import { HelperService } from '../public/helper.service';
import { MobileFileService } from './mobile.file.service';
import { StoreEventsBookingsActionType } from '../stores/store-events-bookings/+state/store-event.actions';

export interface IoAction {
  type: string;
  blob: Blob;
  filename: string;
}

const isIo = (io: any): io is IoAction => {
  return (
    (io as IoAction).blob !== undefined &&
    (io as IoAction).filename !== undefined
  );
};

@Directive({
  selector: '[appDownload]',
})
export class DownloadDirective implements OnInit, OnDestroy {
  subscription: Subscription;

  constructor(
    private actions$: Actions,
    private helperService: HelperService,
    private mobileFileService: MobileFileService,
  ) {}

  ngOnInit() {
    this.subscription = this.actions$
      .pipe(
        ofType<IoAction>(
          StoresActionType.DownloadQRImageSuccess,
          StoresActionType.DownloadQRPdfSuccess,
          StoresActionType.DownloadQRImagesSuccess,
          StoresActionType.DownloadQRFullPdfSuccess,
          StoresActionType.DownloadOrderItemsXlsSuccess,
          StoresActionType.DownloadCustomersListSuccess,
          StoreLocationActionType.DownloadLocationQRImageSuccess,
          StoreLocationActionType.DownloadLocationQRPdfSuccess,
          StoresCatalogActionType.DownloadTranslateCatalogXlsSuccess,
          StoresCatalogActionType.DownloadToUpdateCatalogXlsSuccess,
          StoresCatalogActionType.DownloadOfferOrCategoryImageSuccess,
          StoresCatalogActionType.DownloadProductTemplateSuccess,
          StoresCatalogActionType.DownloadProductExcelSuccess,
          StoreSubscriptionsActionType.DownloadPurchaseInvoicePdfSuccess,
          StoreOrderActionType.DownloadOrderPdfSuccess,
          UserActionType.DownloadVoucherPdfSuccess,
          StoresActionType.DownloadFlyerFileSuccess,
          PlatformActionType.DownloadTenantLogoSuccess,
          StoreLocationActionType.DownloadToUpdateLocationXlsSuccess,
          StoreEventsBookingsActionType.DownloadEventCustomerXlsSuccess,
        ),
        filter<IoAction>(isIo),
        map((response) => {
          if (this.helperService.isMobileApp()) {
            this.mobileFileService.writeFileOnDevice(
              response.filename,
              response.blob,
              true,
            );
            return;
          }

          return FileSaver.saveAs(response.blob, response.filename);
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
